import { STORE_TOKEN } from "../actionTypes/auth";

const initialState = {
  refreshToken: null,
  idToken: null,
  isAdmin: null,
  ssoId: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_TOKEN:
      return setToken(state, action);
    default:
      return state;
  }
};

function setToken(state, action) {
  return {
    ...state,
    refreshToken: action.payload.refreshToken,
    idToken: action.payload.idToken,
    isAdmin: action.payload.isAdmin,
    ssoId: action.payload.ssoId
  };
}

export default reducer;
